import CustomerFormReducer from "@common/redux/reducers/CustomerFormReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class CustomerFormAction extends BaseAction {
  setLoadingCustomers = async (value) =>
    await this.dispatch({ loadingCustomers: value });
}

const action = new CustomerFormAction(CustomerFormReducer);

export default action;
